import { useQuery } from "@apollo/client";
import { Alert, Skeleton, Typography } from "@mui/material";
import { useMemo } from "react";

import { useAppSelector } from "../../../app/hooks";
import { tokenOptions } from "../../../backend/graphql";
import { useDiamondOptionsQuery } from "../StoneSearch/useDiamondOptions";
import FactorMatrix, { latestColorFactors } from "./FactorMatrix";
import {
  GET_LATEST_PRICING_TRENDS,
  GetLatestPricingTrendsQueryData,
} from "./graphql";

const FactorMatrixView = () => {
  const token = useAppSelector((state) => state.auth.token);
  const pricingTrendsQueryResult = useQuery<GetLatestPricingTrendsQueryData>(
    GET_LATEST_PRICING_TRENDS,
    tokenOptions(token),
  );
  const {
    diamondOptions,
    loading: diamondOptionsLoading,
    error: diamondOptionsError,
  } = useDiamondOptionsQuery();

  const rows = useMemo(
    () =>
      latestColorFactors(
        pricingTrendsQueryResult.data?.latestPricingTrends ?? [],
      ),
    [pricingTrendsQueryResult.data],
  );

  if (pricingTrendsQueryResult.error) {
    return <Alert severity="error">Error loading pricing trends.</Alert>;
  }
  if (pricingTrendsQueryResult.loading || diamondOptionsLoading) {
    return <Skeleton variant="rounded" width="100%" height={300} />;
  }

  if (diamondOptionsError || !diamondOptions) {
    return <Alert severity="error">Error loading diamond options.</Alert>;
  }

  if (rows.length === 0) {
    return (
      <Typography color="text.secondary">
        No pricing factors available.
      </Typography>
    );
  }

  return (
    <FactorMatrix
      rows={rows}
      intensities={diamondOptions.fancyIntensities}
      primaries={diamondOptions.fancyColors}
    />
  );
};

export default FactorMatrixView;
